<template>
  <v-container
    grid-list-md
    text-center
    v-if="!this.$store.state.isShowLoadingMessage && showMenu"
  >
    <v-row row wrap>
      <v-col xs12>
        <h1 :class="getConfigItem('H1_WELCOME_TEXT_CLASS')">
          {{ this.$store.state.nexaConfig.WELCOME_TEXT }}
        </h1>
        <h1 :class="getConfigItem('H1_WELCOME_TEXT_CLASS')">
          {{ this.$store.state.nexaConfig.WELCOME_TEXT_2 }}
        </h1>
        <h2
          class="text-xs-center"
          v-if="getConfigItem('HIDE_HOW_CAN_WE_TEXT', true)"
        >
          <span v-html="this.$store.state.nexaConfig.HOW_CAN_WE_TEXT"></span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12>
        <v-btn
          v-if="!this.isCaseExists()"
          class="main-menu-btn main-welcome-button"
          :style="{ color: SECONDARY_COLOUR_TEXT }"
          color="secondary"
          v-on:click="joinQueue()"
          >{{ this.$store.state.nexaConfig.BTN_JOIN_QUEUE_TEXT }}</v-btn
        >
        <v-btn
          v-else
          color="secondary main-welcome-button"
          :style="{ color: SECONDARY_COLOUR_TEXT }"
          class="main-menu-btn"
          v-on:click="ticketStatus()"
          >{{ this.$store.state.nexaConfig.BTN_TICKET_STATUS_TEXT }}</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 v-if="this.bookingUrl">
        <v-btn
          color="secondary"
          :style="{ color: SECONDARY_COLOUR_TEXT }"
          class="main-menu-btn"
          :href="this.bookingUrl"
          target="_blank"
          v-html="this.bookingTitle"
        ></v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 v-if="getConfigItem('CHECKIN_BTN_ENABLED', true)">
        <v-btn
          color="secondary"
          :style="{ color: SECONDARY_COLOUR_TEXT }"
          class="main-menu-btn"
          v-on:click="checkInAppointment()"
          >{{ this.$store.state.nexaConfig.BTN_CHECK_IN_TEXT }}</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { helper } from "@/helper";
import cookieMixin from "@/mixins/cookieMixin";
import utilMixin from "@/mixins/utilMixin";
import serviceMixin from "@/mixins/serviceMixin";
import loadingMixin from "@/mixins/loadingMixin";
import configAliasMixin from "@/mixins/configAliasMixin";
import { mapGetters } from "vuex";
import axios from "axios";
import store from "@/store";

export default {
  mixins: [
    cookieMixin,
    utilMixin,
    serviceMixin,
    loadingMixin,
    configAliasMixin,
  ],
  data: () => {
    return {
      step: 1,
      showMenu: false,
      isShowOverlay: false,
      overlayTitle: "",
      overlayMessage: "",
      overlaySolveMethod: null,
    };
  },
  computed: {
    ...mapGetters([
      // "isConfigLoaded",
      // "isShowLoadingMessage",
      // "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
  },
  mounted: function () {
    this.geoCheck();
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.query.token) {
      const queryToken = to.query.token;
      helper.processToken(queryToken);
    }

    const userCookie = helper.getUserCookie();

    let requireAuthentication = store.getters.getConfigItem(
      "REQUIRES_AUTHENTICATION",
      true
    );

    if (process.env.VUE_APP_ISDEBUGGING)
      console.log(
        "Home - beforeRouteEnter - REQUIRES_AUTHENTICATION",
        requireAuthentication
      );

    if (requireAuthentication && userCookie == null) {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log(
          "requireAuthentication: " +
            requireAuthentication +
            " userCookie:" +
            userCookie
        );
      window.location.replace(store.getters.getConfigItem("AUTH_URL"));
      return;
    }

    if (store.getters.getConfigItem("BYPASS_ALL_AUTHENTICATION") != "true") {
      if (userCookie == null) {
        next("/InputUserInfo");
        return;
      } else {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    geoCheck() {
      //GEO CHECKING
      if (this.getConfigItem("GEOFENCE_ENABLED", true)) {
        let that = this;
        this.showLoading(this.$store.state.nexaConfig.CHECK_LOCATION_TEXT);

        try {
          var geoCoordConfig = JSON.parse(
            this.$store.state.nexaConfig.GEOFENCE_COORDS
          );
        } catch (err) {
          this.showError("Geofencing config error", err);
        }
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (process.env.VUE_APP_ISDEBUGGING)
              console.log(
                "%c geofencing coords: " +
                  position.coords.latitude +
                  "," +
                  position.coords.longitude,
                "color:lime",
                {
                  geoCoordConfig,
                }
              );
            that.$root.hideLoading();
            let isInRange = false;
            for (let i = 0; i < geoCoordConfig.length; i++) {
              let fenceCoord = geoCoordConfig[i];

              if (
                this.isPointInCircle(
                  position.coords.latitude,
                  position.coords.longitude,
                  fenceCoord.lat,
                  fenceCoord.long,
                  this.$store.state.nexaConfig.GEOFENCE_RADIUS
                )
              ) {
                if (process.env.VUE_APP_ISDEBUGGING)
                  console.log("%c is in range", "color:lime");

                isInRange = true;
                break;
              }
            }

            if (!isInRange) {
              this.showGeoError();
            } else {
              this.initialProcedure();
            }
          },
          () => {
            that.$root.hideLoading();
            if (process.env.VUE_APP_ISDEBUGGING)
              console.log("%c geo error", "color:lime");
            if (this.getConfigItem("GEOFENCE_ENFORCED", true)) {
              this.showGeoError();
            } else {
              this.initialProcedure();
            }
          }
        );
      } else {
        this.initialProcedure();
      }
    },
    showGeoError() {
      this.$store.commit("showOverlay", {
        overlayTitle: "Location Policy",
        overlayMessage: this.$store.state.nexaConfig.GEOFENCE_TEXT,
        solveMethod: () => {
          this.refreshHome();
        },
        buttonLabel: "Try again",
      });
    },
    refreshHome() {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("%c RefreshHome", "color:magenta");
      let self = this;
      setTimeout(function () {
        //do what you need here
        self.$router.push("/");
        self.$router.go();
      }, 50);
    },
    initialProcedure() {
      this.showMenu = true;

      // check for existing case cookie, if obsolete then delete it.
      let casePayloads = helper.getCaseCookie();

      if (casePayloads != null && casePayloads.CaseId != null) {
        this.callGetService(
          this,
          "/Cases/" + casePayloads.CaseId,
          null,
          (response) => {
            if (response.data.ResolutionDesc != "") {
              helper.deleteCaseCookie();
            }
            this.$forceUpdate();

            // check for active case for current user
            this.checkOpenCase();
          },
          null,
          this.$store.state.nexaConfig.CHECK_COOKIE_TICKET_TEXT
        );
      }

      // check for active case for current user
      this.checkOpenCase();
    },
    getDefaultTemplateURLs() {
      // using sample token
      const params = {};
      const token =
        "bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjEyMzQ1Njc4OTAiLCJGaXJzdE5hbWUiOiJNYXJzZWwiLCJMYXN0TmFtZSI6IkFpcGFzc2EiLCJFbWFpbCI6Ik1hcnNlbFdpbGxlbS5BaXBhc3NhQG1pdHJhaXMuY29tIiwiTW9iaWxlIjoiMDQwMTEzMzM5MyJ9.GDwyCDfUdAk0eXa7hLhmZyZZ7iCzfPiYUZGXTDwbIKw";

      const options = {
        params,
        headers: {
          Authorization: token,
        },
      };

      return axios.get(
        "/System/ContentValues",
        {
          params: {
            TemplateCategory: "VirtualQueue",
            LanguageCode: "en",
          },
        },
        options
      );
    },
    checkOpenCase() {
      let userCookie = helper.getUserCookie();
      // if user doesn't login without the student id / personal id
      if (userCookie != null && userCookie.withoutStudentId) {
        return;
      }

      let caseSearchParam = "";

      if (userCookie != null) {
        if (userCookie[this.$store.state.nexaConfig.TOKEN_ID_NAME]) {
          if (
            userCookie[this.$store.state.nexaConfig.TOKEN_ID_NAME].length == 0
          ) {
            // no data:
            return;
          }
          // i.e. have student number / personalId
          //    caseSearchParam = "PersonalId=" + userCookie.userName;
          caseSearchParam =
            "&CustomProperty=" +
            this.$store.state.nexaConfig.PROCESS_CUSTOM_PROPERTY_ID_NAME +
            "&CustomPropertyValue=" +
            userCookie[this.$store.state.nexaConfig.TOKEN_ID_NAME];
        } else {
          if (userCookie.mobile == null || userCookie.mobile.length == 0) {
            // no data:
            return;
          }
          caseSearchParam = "&ExtRef=" + userCookie.mobile;
        }
      } else {
        // no identifying data:
        return;
      }

      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("caseSearchParam", caseSearchParam);

      // grab existing cooking so you don't overwrite some details:
      let currentCaseCookie = helper.getCaseCookie();

      this.callGetService(
        this,
        "/Cases?Status=10" + caseSearchParam,
        null,
        (response) => {
          if (response.data.caseResults.length > 0) {
            let currentOpenCase = response.data.caseResults[0];

            if (!currentCaseCookie) {
              helper.setCaseCookie(currentOpenCase.CaseId, false);
            } else {
              if (currentCaseCookie.CaseId != currentOpenCase.CaseId) {
                helper.setCaseCookie(
                  currentOpenCase.CaseId,
                  false,
                  null,
                  null,
                  this.getConfigItem("DATA_RETENTION_PERIOD")
                );
              } else {
                helper.setCaseCookie(
                  currentOpenCase.CaseId,
                  false,
                  currentCaseCookie.UnitName,
                  currentCaseCookie.classificationName,
                  this.getConfigItem("DATA_RETENTION_PERIOD")
                );
              }
            }
          }

          this.$forceUpdate();
        },
        (error) => {
          console.log("Error CasesSearch:" + error); // TODO: error management
        },
        this.$store.state.nexaConfig.CHECK_OPEN_TICKET_TEXT
      );
    },
    joinQueue() {
      this.$router.push("Enqueue");
    },
    ticketStatus() {
      this.$router.push("EnqueueInfo");
    },
    checkInAppointment() {
      this.$router.push("AppointmentCheckIn");
    },
    isCaseExists() {
      return helper.getCaseCookie() != null;
    },
  },
};
</script>
<style></style>
